fx.ns("models", class ThemeCollection extends fx.Model {

	constructor(data)
	{
		super(data);
	}


     get defaults()
    {
        return { visible: 0 };
    }


});